module.exports = __webpack_public_path__ + "img/btn_HIGH_lose.26e8232d.png";